<template>
  <div v-if="isLegendVisible === true">
    <div class="legend-box">
      <div class="help">
        {{$t('legendHelp')}}
      </div>
      <div class="single" v-for="n in 6">
        <div class="multi">{{ $t('multi'+n) }}</div>
        <div class="bar" :class="'multi'+n"></div>
      </div>
    </div>
  </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {isMobileOnly, isTablet} from "mobile-device-detect";
import {checkIsMobileDevice ,checkIsTabletDevice} from "@/plugins/device-inspector";

export default {
  name: "Legend",
  data: () => ({
    modal: false
  }),
  computed: {
    ...mapGetters({
      'getGameConsole': 'settings/getGameConsole',
      'getShowMultiplicityLegendMobile': 'settings/getShowMultiplicityLegendMobile'
    }),
    isLegendVisible (){
      let isVisible = true;

      if(this.getGameConsole === 'classic'){
        if(this.checkIsMobile() || this.checkIsTablet()){
          // isVisible = false;
          isVisible = this.getShowMultiplicityLegendMobile
        }
      }
      return isVisible
    }
  },
  methods:{
    ...mapActions({

    }),

    checkIsMobile(){
      return checkIsMobileDevice()
    },

    checkIsTablet(){
      return checkIsTabletDevice()
    },
  },
}
</script>

<style>

.bet-console-prefix .legend-box{
  display: flex;
  background: var(--header-color);
  justify-content: center;
  align-items: center;
}

.bet-console-prefix .legend-box .help{
  font-size: var(--font-size-md);
  margin-right: 2%;
}

.bet-console-prefix .legend-box .single{
  padding: 4px 0;
  margin-right: 10px;
  width: 55px;
  text-align: center;
}


.bet-console-prefix .legend-box .bar{
  border: 2px solid;
}
.bet-console-prefix .legend-box .bar.multi1{
  border-color: var(--odd-mult-1);
}
.bet-console-prefix .legend-box .bar.multi2{
  border-color: var(--odd-mult-2);
}
.bet-console-prefix .legend-box .bar.multi3{
  border-color: var(--odd-mult-3);
}
.bet-console-prefix .legend-box .bar.multi4{
  border-color: var(--odd-mult-4);
}
.bet-console-prefix .legend-box .bar.multi5{
  border-color: var(--odd-mult-5);
}
.bet-console-prefix .legend-box .bar.multi6{
  border-color: var(--odd-mult-6);
}

.bet-console-prefix .legend-box .multi{
  font-size: var(--font-size-md);
}
</style>